interface ScoreMeterProps {
  value: number;
  label?: string;
}

export function ScoreMeter({ value, label = 'score' }: ScoreMeterProps): React.JSX.Element {
  const normalized = Math.max(0, Math.min(100, value));
  return (
    <div className="score-meter" aria-label={`${label}: ${normalized} out of 100`}>
      <div className="score-meter-track">
        <div className="score-meter-fill" style={{ width: `${normalized}%` }} />
      </div>
      <small>{normalized}/100</small>
    </div>
  );
}
